export function buildAttributeIdWithIndex(text: string, index: number = 0): string {
  const trimmedText = text.trim();
  if (trimmedText === '') {
    return trimmedText;
  }
  return trimmedText.split(' ').join('-').toLowerCase() + '-' + index;
}
